<template lang="html">
    <div class="popover-primary-body assign-truck">
      <div class="assign-truck-card">
      <ul class="assign-truck-gate">
        <li>
          <h3>{{$t('INDENT_CONTAINER_NUMBER')}}</h3>
          <ul class="input-field">
            <li>
              <div class="input-line w200">
                <input type="text" v-model="containerNumber" placeholder="900132CTZPXXXX">
              </div>
            </li>
          </ul>
        </li>
      </ul>
      </div>
      <div class="assign-truck-card">
      <ul class="assign-truck-gate">
        <li>
          <h3>{{$t('INDENT_LINE_SEAL_NUMBER')}}</h3>
          <ul class="input-field">
            <li><div class="input-line">
              <div class="input-line w200">
                <input type="text" v-model="lineSealNumber" placeholder="900132CTZPXXXX">
              </div>
            </div></li>
          </ul>
        </li>
        </ul>
        </li>
      </ul>
      </div>
      <div class="popover-primary-footer">
        <div class="submit-button">
          <button class="btn primary-button" @click="containerPicked">
            {{$t('INDENT_SUBMIT')}}
          </button>
        </div>
      </div>
  </div>
</template>
<script>
import debounce from 'debounce';

export default {
  props: ['order'],

  data() {
    return {
      lineSealNumber: '',
      containerNumber: '',
    };
  },
  methods: {
    async containerPicked() {
      const { order_number: orderNumber } = this.order;
      const data = {};
      data.container_number = this.containerNumber;
      data.line_seal_number = this.lineSealNumber;
      try {
        const result = await this.$store.dispatch('order/containerPicked', { id: orderNumber, data });
        if (result.order_number) {
          this.$emit('done', 'containerPickup');
          this.$success({ message: this.$t('INDENT_CONTAINER_PICKUP_SUCCESS_MSG') });
        } else {
          this.$error({ message: this.$t('INDENT_CONTAINER_PICKUP_ERROR_MSG') });
        }
      } catch (err) {
        this.$error({ message: this.$t('INDENT_CONTAINER_PICKUP_ERROR_MSG') });
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@common/styles-shipper/settings";

.assign-truck{
    background-color:#fff;
    text-align: left;
    .radio-btn{
      padding: 0 10px 0 0;
    }
  ul{
     @extend %list-unstyled;
  &.-header{
     margin: 0 0 30px 0;
  }
  li{
    display: inline-block;
    vertical-align: top;
  &.popover-title{
     @extend %title;
  }
    }
  }
  &-card{
     margin: 20px 0 0 0;
  h3{
      color: $sec-text;
      font-size: 10px;
      font-weight: normal;
      // letter-spacing: 0.83px;
    }
  }
  &-gate{
  li{
     color: $sec-text;
     font-family:$fontSemibold;
     font-size: 12px;
     letter-spacing: 0.3px;
     padding: 0 20px 0 0;
    .input-field{
        display: inline-block;
        &.datepicker-card{
          width: 200px;
        }
    .input-line{
        input{
        border-top: 1px solid transparent;
        border-left: 1px solid transparent;
        border-right: 1px solid transparent;
        border-bottom: 1px solid #DEE5E6;
        background-color: transparent;outline: none;
        border-radius: 0;
            width: 100%;
      }
      &.width30 input{width: 30px;}
      &.width40 input{width: 40px;}
      // &.width100 input{width: 100px;}
      }
     }
    }
   }
  .submit-button{
       // float: right;
       // margin: 20px 0 0 0;
  .primary-button{
      @extend %primary-btn;
      text-transform: uppercase;
   }
  }
  .w80{
    width: 80px !important;
  }
}
</style>
